import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getReferralAPI(id: string) {
  return serviceRequest(() => Service.referralControllerGetForCurrentUser(id));
}
